/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Broker_PendingInputs */

const cs_ebr_broker_pending = /** @type {(inputs: Ebr_Broker_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vznikne s importem`)
};

const en_ebr_broker_pending = /** @type {(inputs: Ebr_Broker_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created by this import`)
};

/**
* | output |
* | --- |
* | "Created by this import" |
*
* @param {Ebr_Broker_PendingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_broker_pending = /** @type {((inputs?: Ebr_Broker_PendingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Broker_PendingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_broker_pending(inputs)
	return cs_ebr_broker_pending(inputs)
});